import { LightningElement, api } from "lwc";
import type { PreworkDetails } from "./types";
export type { PreworkDetails };

export default class Prework extends LightningElement {
    @api preworksummary: PreworkDetails = null!;

    private get getImageUrl() {
        return this.preworksummary.imgUrl;
    }

    private get getTitleUrl() {
        return this.preworksummary.titleUrl;
    }
}
